module.exports = __webpack_public_path__ + "media/images/number_4-9dfccd7bd896ef9e2597a1458d9c2052.png";